export const START_ROUTE_PATH = 'start'
